import { t } from "i18next"
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AlertNotDateWhenChange from "../common/alertNotDateWhenChange";
import HeaderModal from "../headerModal"
import ListDayTimeslot from "./listDayTimeslot";
import ListingPrenotationByBookingId from "./listingPrenotationByBookingId";
import { useAppDispatch } from "../../redux";
import { updatePrenotationViewAll } from "../../redux/reducer/prenotationViewReducer";
import { loadDatesWithTimeslot } from "../../redux/reducer/prenotationReducer";

const PopUpViewPrenotationByTimeslot = (props: any) => {
  // internal state
  const [alertTimeslotInfo, setAlertTimeslotInfo] = useState<null | any>(null); // details for timeslot move/delete success message
  // redux state
  const { selectedDay } = useSelector((state: any) => state.prenotationView)
  const { namePharmacy } = useSelector((state: any) => state.login);
  const dispatch = useAppDispatch();

  const closePopUp = () => {
    dispatch(updatePrenotationViewAll(['', '', '']))

    if (typeof props.closePopUp === 'function') {
      props.closePopUp()
    }
  }

  // when the message is shown, it will disappear after 10 seconds
  useEffect(() => {
    if (alertTimeslotInfo) {
      setTimeout(resetAlertTimeslotInfo, 10 * 1000);
    }
  }, [alertTimeslotInfo])

  const resetAlertTimeslotInfo = () => {
    setAlertTimeslotInfo(null);
  }

  // Initial update, first render only.
  useEffect(() => {
    // Redux state used in children.
    dispatch(updatePrenotationViewAll([props.selectedDay, props.selectedTimeslotId, props.selectedBookingId]))

    // Redux dateFilter, used in children date picker
    dispatch(loadDatesWithTimeslot())
  }, [])

  return (
    <div className="PopUpViewPrenotationByTimeslot active">
      <HeaderModal textButtonRight={t('close')} handleClick={closePopUp} title={t('title-header-modale', { nameBrand: namePharmacy })} />
      <div className="Container container ">
        <div className="row m-0">
          <div className="col-lg-3">
            <ListDayTimeslot
            // onTimeslotSelection={resetAlertTimeslotInfo}
            />
          </div>
          <div className="col-lg-9">
            <>
              {/* timeslot move/delete success message */}
              {((alertTimeslotInfo) ?
                <AlertNotDateWhenChange
                  alertTimeslotInfo={alertTimeslotInfo}
                  selectedDay={selectedDay}
                // onDayClick={resetAlertTimeslotInfo}
                />
                :
                <></>
              )}

              <ListingPrenotationByBookingId
                changeInfoOldAttendances={setAlertTimeslotInfo}
              />
            </>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PopUpViewPrenotationByTimeslot
